import React from "react";
import { Navigate } from "react-router-dom";
import { FeatureModule } from "@/shared/types/routing";
import { BookAppointmentsIcon } from "@/shared/ui/icons";

const BookAppointments = React.lazy(() => import("./BookAppointments"));
const ApplicationForm = React.lazy(() => import("./ApplicationForm"));
const ApplicantVerification = React.lazy(() => import("./ApplicantVerification"));

const BookAppointmentsModule: FeatureModule = {
    name: "book-appointments",
    routes: [
        {
            path: "/book-appointment",
            element: <BookAppointments />,
            meta: {
                label: "booking:steps.bookAppointments",
                icon: BookAppointmentsIcon,
                showInSidebar: true,
                requiresAuth: true,
            },
        },
        {
            path: "/book-appointment/application-form/:profileId?",
            element: <ApplicationForm />,
            meta: {
                label: "booking:steps.applicationForm",
                showInSidebar: false,
                requiresAuth: true,
            },
        },
        {
            path: "/book-appointment/slot-selection",
            element: <Navigate to="/book-appointment" replace />,
            meta: {
                label: "booking:steps.slotSelection",
                showInSidebar: false,
                requiresAuth: true,
            },
        },
        {
            path: "/book-appointment/applicant-verification",
            element: <ApplicantVerification />,
            meta: {
                label: "booking:steps.applicantVerification",
                showInSidebar: false,
                requiresAuth: true,
            },
        },
        {
            path: "/book-appointment/booking",
            element: <Navigate to="/book-appointment" replace />,
            meta: {
                label: "booking:steps.appointmentBooking",
                showInSidebar: false,
                requiresAuth: true,
            },
        },
    ],
};

export default BookAppointmentsModule;
